import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";

import {HeaderModule} from "./header/header.module";
import {NavigationModule} from "./navigation/navigation.module";
import { MainLayoutComponent } from './app-layouts/main-layout.component';
import { RouterModule } from "@angular/router";
import { AuthLayoutComponent } from './app-layouts/auth-layout.component';
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { TooltipModule } from "ngx-bootstrap/tooltip";
//import { SharedComponentsModule } from "@app/cp/shared/sharedComponents.module";
import { AcadiaDocsComponent } from "@app/cp/shared/components/acadia-docs/acadia-docs.component";

@NgModule( {
    imports: [
        CommonModule,
        HeaderModule,
        NavigationModule,
        FormsModule,
        RouterModule,
        TooltipModule,
        BsDropdownModule,
        //SharedComponentsModule,
    ],
    declarations: [
        MainLayoutComponent,
        AuthLayoutComponent,
        AcadiaDocsComponent
  ],
  exports:[
    HeaderModule,
    NavigationModule,
      AcadiaDocsComponent
  ]
})
export class SmartadminLayoutModule{

}
